import {UpsellDialogEntryPoint} from '@Libraries/upsell-dialog.library';
import type {ReactElement} from 'react';
import {StyleTile} from '@Components/style-tile/style-tile';
import {BrandKitSource} from '@Components/mystuff-brands/brand-kits.types';
import {STYLE_TILE_COLORS_LIMIT} from '@Components/style-tile/style-tile.types';
import type {BrandKitStyleTileProps} from './brand-kit-style-tile.types';
import {openAppropriateUpsellingDialogForBrandKits, shouldUpsellHalloweenBrandKit, trackHalloweenBrandKitUsageIfApplicable} from '@Libraries/brands-library';
import {getBrandKitLogoURL, getOrderedBrandColorHexes} from '@Libraries/brand-kit-display.library';

export function BrandKitStyleTile({brandKit, brandColors, brandLogos, brandFonts, onClickBrandKit, showCursorPointer = true, ...props}: BrandKitStyleTileProps): ReactElement {
  const logoURL = getBrandKitLogoURL(brandLogos);
  const colorHexes = getOrderedBrandColorHexes(brandColors, STYLE_TILE_COLORS_LIMIT);

  const onClick = (): void => {
    trackHalloweenBrandKitUsageIfApplicable(brandKit.brandId);
    if (shouldUpsellHalloweenBrandKit(brandKit.brandId)) {
      openAppropriateUpsellingDialogForBrandKits({entryPoint: UpsellDialogEntryPoint.BRAND_KIT_STYLE_TILE});
      return;
    }

    onClickBrandKit(brandKit.brandId, colorHexes, logoURL, brandFonts[0]?.fontFamily);
  };

  return (
    <StyleTile
      onClick={onClick}
      imageURL={logoURL}
      colorHexes={colorHexes}
      fontFamily={brandFonts[0]?.fontFamily}
      tileText={brandKit.name}
      tileTextClasName={brandKit.source === BrandKitSource.HALLOWEEN_PROMOTION ? 'content-halloween' : ''}
      isSelected={props.isSelected}
      showCursorPointer={showCursorPointer}
      {...props}
    />
  );
}
